import React, { useState } from 'react';

import { useGlobal } from '../../../../contexts/Global/context';

import { buscaBeneficiarioAlteracaoCadastral } from '../../../../services/beneficiario/beneficiarios';

import { addMaskCpf } from '../../../../utils/formatValues';

import Icon from '../../../../components/Icons';

import Accordion from '../../../../components/Accordion';

import SearchContainer from '../../../../components/SearchContainer';
import DataTableMuiCarteirinha from './DataTableMuiCarteirinha';

import { PageContainer, ContainerDataTable } from '../../../../styles/styles';
import TabMenu from '../../../../components/TabMenu';
import { carteirinhaDigitalTabs } from '../Tabs';
import { carteirinhaDigitalSaude, imagemCarteirinha } from '../../../../services/beneficiario/carteiras';
import { generatePdf } from '../../../../utils';
import CarteirinhaDigital from './PdfCarteirinha';

import * as S from './styles';

function PesquisarBeneficiarioCarteirinhaDigital() {
    const { dataActiveContract, contrastTheme } = useGlobal();

    const emptyMessage = 'Não encontramos esse beneficiário. Você pode fazer uma nova pesquisa.';
    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [dataTable, setDataTable] = useState([]);

    async function handleSearch(value) {
        setLoading(true);

        setAlreadySearched(false);

        const response = await buscaBeneficiarioAlteracaoCadastral(value, dataActiveContract.numero);
        const treatedResponse = response
            ? response.map((element, index) => ({
                  ...element,
                  index,
                  cpf: addMaskCpf(element.cpf),
              }))
            : [];
        setLoading(false);

        setDataTable(treatedResponse);

        setAlreadySearched(true);
    }

    async function convertImgPng(tipoCarteirinha) {
        const payloadimagemCarteirinha = {
            canal: 'M',
            // eslint-disable-next-line object-shorthand
            tipoCarteirinha: tipoCarteirinha,
        };

        const reponseImage = await imagemCarteirinha(payloadimagemCarteirinha);
        const imagemBlob = new Blob([reponseImage], { type: 'image/jfif' });
        const imagemUrl = URL.createObjectURL(imagemBlob);
        const imagem = new Image();
        imagem.src = imagemUrl;

        const pngDataUrlPromise = new Promise((resolve, reject) => {
            imagem.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = imagem.width;
                canvas.height = imagem.height;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(imagem, 0, 0);

                const pngDataUrl = canvas.toDataURL('image/png');

                resolve(pngDataUrl);
            };

            // eslint-disable-next-line func-names
            imagem.onerror = function () {
                reject(new Error('Erro ao carregar imagem'));
            };
        });

        return pngDataUrlPromise;
    }

    async function downloadPdfCarteirinha(row) {
        const payloadBuscaCarteirinha = {
            cabecalho: {
                canal: 'M',
                codigoEmpresaOrigem: '1',
                divisaoNegocio: '1',
                empresaOrigemAtendimento: '1',
                origemContrato: '1',
                tipoContrato: '1',
                token: '1',
                unidadeNegocio: '1',
            },
            carteirinha: row.numCarteira,
        };

        const response = await carteirinhaDigitalSaude(payloadBuscaCarteirinha);
        const reponseImg = await convertImgPng(response.listaCarteirinhaDigitalSaude[0].tipoCarteirinha);
        if (reponseImg) {
            generatePdf(
                <CarteirinhaDigital form={response.listaCarteirinhaDigitalSaude[0]} image={reponseImg} />,
                'Carteirinha Digital'
            );
        }
    }

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.numCarteira || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 600px)', height: '60px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf || '-',
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '160px' }),
        },
        {
            key: 'tipoOperacao',
            selector: (row) => row.tipo || '-',
            name: 'Tipo',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'arquivoRelatorio',
            selector: (row) => row,
            name: '',
            sortable: false,
            direction: 'left',
            mutation: (row) => (
                <S.CellWithIcon
                    onClick={(e) => {
                        e.stopPropagation();
                        downloadPdfCarteirinha(row);
                    }}
                >
                    <Icon name="file_download" tooltip="Baixar" size={16} />
                    <span
                        style={{
                            color: contrastTheme ? '#FFF333' : '#EC6E0C',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                    >
                        Baixar
                    </span>
                </S.CellWithIcon>
            ),
            customStyles: ({ arquivoRelatorio }) => ({ width: '200px', cursor: arquivoRelatorio && 'pointer' }),
        },
    ];

    return (
        <>
            <PageContainer>
                <TabMenu components={carteirinhaDigitalTabs} />
                <Accordion title="Pesquisar beneficiário" hasCollapse={false}>
                    <SearchContainer
                        field={{
                            id: 'searchField',
                            label: 'Digite o nº da carteirinha, nome ou CPF',
                            required: true,
                        }}
                        onSearch={handleSearch}
                    />
                </Accordion>
            </PageContainer>
            <ContainerDataTable>
                <DataTableMuiCarteirinha
                    clickableRow
                    data={dataTable}
                    loading={loading}
                    columns={columnsHead}
                    emptyMessage={emptyMessage}
                    alreadySearched={alreadySearched}
                    firstOrderBy="numCarteirinha"
                />
            </ContainerDataTable>
        </>
    );
}

export default PesquisarBeneficiarioCarteirinhaDigital;
